// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiAppeal {
    static getAttributeTypeMap() {
        return PharmacyBiAppeal.attributeTypeMap;
    }
}
PharmacyBiAppeal.discriminator = undefined;
PharmacyBiAppeal.additionalProperties = false;
PharmacyBiAppeal.attributeTypeMap = [
    {
        "name": "available",
        "baseName": "available",
        "type": "string"
    },
    {
        "name": "contactFax",
        "baseName": "contactFax",
        "type": "string"
    },
    {
        "name": "contactOrg",
        "baseName": "contactOrg",
        "type": "string"
    },
    {
        "name": "contactPhone",
        "baseName": "contactPhone",
        "type": "string"
    },
    {
        "name": "notificationMethod",
        "baseName": "notificationMethod",
        "type": "string"
    },
    {
        "name": "requiredDocuments",
        "baseName": "requiredDocuments",
        "type": "string"
    },
    {
        "name": "submissionDeadline",
        "baseName": "submissionDeadline",
        "type": "string"
    },
    {
        "name": "turnaroundTime",
        "baseName": "turnaroundTime",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiAppeal.js.map